var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"md":"5"}},[_c('Tabla',{attrs:{"modulo":"diagnosticos","nuevoTxt":"Nuevo Diagnostico","propId":"IdProblema","propDescripcion":"Problema","singular":"Diagnostico"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }